import templateUrl from "emun.invoice/inv/inv-container.htm";
import listTemplateUrl from "emun.invoice/inv/inv-list.htm";
import controller from "emun.invoice/inv/inv-container.controller";

const isList = (type = "") => type === "list" || type === "mutli-view";

export default {
  bindings: {
    customer: "<",
    ngModel: "=?",
    // retailerId: "<?",
    orderId: "<?",
    invoiceId: "<?",
    hideHeader: "@",
    layout: "@",
    detailRoute: "@",
    disableQueryString: "<",
    mode: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      console.debug(templateUrl, {
        $element,
        $attrs,
        listTemplateUrl,
        templateUrl,
      }) ||
      $attrs.templateUrl ||
      (isList($attrs.layout) ? listTemplateUrl : templateUrl)
    );
  },
};
